// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finances[data-v-98cea6b8]{padding:32px 0;background:#eff1f5}", ""]);
// Exports
module.exports = exports;
